import { useEffect, useState } from "react";

import { Order } from "@web-app/types";
import { isActiveOrderDelayed } from "@web-app/utils/helpers";

interface UseDelayedOrderDetectionProps {
  orderIds?: string[];
  orders?: Map<string, Order>;
  routedOrdersDraftEstimatedETA?: Map<string, Date | null>;
}

export function useDelayedOrderDetection({
  orderIds,
  orders,
  routedOrdersDraftEstimatedETA,
}: UseDelayedOrderDetectionProps) {
  const [hasPotentialDelayedOrders, setHasPotentialDelayedOrders] =
    useState(false);

  useEffect(() => {
    let delayedOrdersFound = false;

    if (routedOrdersDraftEstimatedETA && orders) {
      // For CreateRoute scenario - using draft eta
      for (const [orderId, etaDate] of routedOrdersDraftEstimatedETA) {
        delayedOrdersFound = isActiveOrderDelayed(orders.get(orderId), etaDate);
        if (delayedOrdersFound) break;
      }
    } else if (orders && orderIds) {
      // For EditRoute scenario - using order eta
      for (const orderId of orderIds) {
        delayedOrdersFound = isActiveOrderDelayed(orders.get(orderId));
        if (delayedOrdersFound) break;
      }
    } else if (orders) {
      // Fallback - check all orders
      for (const [, order] of orders) {
        delayedOrdersFound = isActiveOrderDelayed(order);
        if (delayedOrdersFound) break;
      }
    }

    setHasPotentialDelayedOrders(delayedOrdersFound);
  }, [orders, routedOrdersDraftEstimatedETA, orderIds]);

  return {
    hasPotentialDelayedOrders,
  };
}
